export class BackupZeroEtlSingleResourceDatabaseNameAffixes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "namePrefix",
            "baseName": "namePrefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "nameSuffix",
            "baseName": "nameSuffix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlSingleResourceDatabaseNameAffixes.attributeTypeMap;
    }
    constructor() {
    }
}
